module.exports = __webpack_public_path__ + "img/loreal_canada.17343a21.webp";